import querystringify from "querystringify";
import { ROUTE_NAMES } from "../../constants/route-names";
import { PLAN_TYPES } from "../../constants/personaldata";

export class PageService {
    static isEnabledFullPlanPage(page) {
        return (
            !page.includes(ROUTE_NAMES.HOME_INSURANCE.LANDING) &&
            !page.includes(ROUTE_NAMES.HOME_INSURANCE.STEP1)
        );
    }
    static appendFixedPlanQueryParam({
        currentQueryString = "",
        targetRoute = "",
        selectedPlanType = null,
    }) {
        const _queryStringMap = querystringify.parse(currentQueryString);
        const _shouldAppendFixedPlanParam =
            PageService.isEnabledFullPlanPage(targetRoute) &&
            selectedPlanType === PLAN_TYPES.FIXED;
        if (_shouldAppendFixedPlanParam) {
            _queryStringMap["fijo"] = "1";
        }
        return querystringify.stringify(_queryStringMap);
    }
}
